import { render, staticRenderFns } from "./BillableItemList.vue?vue&type=template&id=3edb37be&scoped=true"
import script from "./BillableItemList.vue?vue&type=script&lang=js"
export * from "./BillableItemList.vue?vue&type=script&lang=js"
import style0 from "./BillableItemList.vue?vue&type=style&index=0&id=3edb37be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb37be",
  null
  
)

export default component.exports